<template>
  <div class="rectangle-wrapper">
    <div
      class="rectangle"
      :style="{
        width: width + 'px',
        height: height + 'px',
        border: `${borderWidth}px solid ${borderColor}`
      }"
    >
      <svg
        class="diagonal-line"
        :width="svgWidth"
        :height="svgHeight"
        xmlns="http://www.w3.org/2000/svg"
      >
        <!-- 对角线 -->
        <line
          x1="0"
          y1="0"
          :x2="svgWidth"
          :y2="svgHeight"
          :stroke="lineColor"
          :stroke-width="2"
        />
        <!-- 左上角箭头 -->
        <path
          :d="`M0,0 L${arrowSize},0 L0,${arrowSize} Z`"
          :fill="lineColor"
        />
        <!-- 右下角箭头 -->
        <path
          :d="`M${svgWidth},${svgHeight} L${svgWidth - arrowSize},${svgHeight} L${svgWidth},${svgHeight - arrowSize} Z`"
          :fill="lineColor"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'simpleScreenItem',
  props: {
    width: {
      type: Number,
      default: 300
    },
    height: {
      type: Number,
      default: 200
    },
    borderColor: {
      type: String,
      default: '#ffffff'
    },
    borderWidth: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      arrowSize: 8, // 箭头大小
      lineColor: '#ff3399' // 线条颜色
    }
  },
  computed: {
    svgWidth () {
      return this.width - this.borderWidth * 2
    },
    svgHeight () {
      return this.height - this.borderWidth * 2
    }
  }
}
</script>

<style scoped>
.rectangle-wrapper {
  display: flex;
  justify-content: center;
}

.rectangle {
  position: relative;
  background-color: #ffffff;
}

.diagonal-line {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none; /* 防止SVG拦截鼠标事件 */
}
</style>



// WEBPACK FOOTER //
// src/view/graph/Simple/simpleScreenItem.vue